// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"367": "58d0cec8","396": "6a5000ad","437": "420bcd7c","531": "7b50053e","75": "9f999c16",}[chunkId] + ".js"
}